import { ApiError, getApiBaseUrl, http } from './client'
import type {
  LoginBeginResponse,
  LoginFinishRequest,
  LogoutRequest,
  RecoveryBeginResponse,
  RecoveryRequest,
  RefreshRequest,
  RegisterBeginRequest,
  RegisterBeginResponse,
  RegisterFinishRequest,
  RegisterFinishResponse,
  TokenPairResponse,
} from './types'

export const registerBegin = (body: RegisterBeginRequest) =>
  http.post<RegisterBeginResponse>('/v0/auth/register/begin', body, { skipAuth: true })

export const registerFinish = (body: RegisterFinishRequest) =>
  http.post<RegisterFinishResponse>('/v0/auth/register/finish', body, { skipAuth: true })

export const loginBegin = () =>
  http.post<LoginBeginResponse>('/v0/auth/login/begin', undefined, { skipAuth: true })

export const loginFinish = (body: LoginFinishRequest) =>
  http.post<TokenPairResponse>('/v0/auth/login/finish', body, { skipAuth: true })

export const refresh = (body: RefreshRequest) =>
  http.post<TokenPairResponse>('/v0/auth/refresh', body, { skipAuth: true })

export const recoveryBegin = (body: RecoveryRequest) =>
  http.post<RecoveryBeginResponse>('/v0/auth/recovery/begin', body, { skipAuth: true })

export const recoveryFinish = (body: RegisterFinishRequest) =>
  http.post<RegisterFinishResponse>('/v0/auth/recovery/finish', body, { skipAuth: true })

// Logout требует refresh-токен в Authorization, а не access. Делаем ручной fetch
// в обход общего клиента — он добавляет access, а тут нужен refresh.
export async function logout(refreshToken: string): Promise<void> {
  const body: LogoutRequest = { refreshToken }
  const res = await fetch(`${getApiBaseUrl()}/v0/auth/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${refreshToken}`,
    },
    body: JSON.stringify(body),
  })
  if (!res.ok && res.status !== 204) {
    throw new ApiError(res.status, null, `Logout failed (${res.status})`)
  }
}
